import { COLLECTIONS } from "./firebase-collections.js";
/**
 * A delivery's method and the collection it lives in are two names for one fact. Binding them here
 * is the point of this module: every defect in this area came from choosing them separately, where
 * a query naming `checkins` and a mapper saying `MAIL` both compile and quietly disagree.
 */
export const DELIVERY_COLLECTION = {
    STORE: COLLECTIONS.checkins,
    MAIL: COLLECTIONS.mailOrders,
};
/**
 * Turn a stored delivery document into a `Delivery`.
 *
 * New documents carry `deliveryMethod`. Documents written before the field existed do not, and for
 * those the collection they came out of is what says which flow they belong to — so reading through
 * here means the union is discriminated whatever the document's age, without rewriting live data.
 *
 * `document` is `unknown` because every caller passes a Firestore snapshot's `data()`, which is
 * `any` on both the admin and the web SDK. A narrower parameter bought no real checking; it only
 * forced a cast and an extra import at every call site.
 */
export function toDelivery(method, document) {
    return { ...document, deliveryMethod: method };
}
/**
 * The delivery a transaction was created from.
 *
 * The transaction row names it in one of two columns — `storeCheckinId` or `mailOrderId`, a
 * leftover from when the two flows were different document types — and only ever fills one. Which
 * column is set is also the only thing that says which flow the delivery belongs to, so reading the
 * pair anywhere else means re-deriving the method beside the id and risking the two disagreeing.
 */
export function transactionDeliveryLink(transaction) {
    if (transaction.storeCheckinId) {
        return { deliveryMethod: "STORE", id: transaction.storeCheckinId };
    }
    if (transaction.mailOrderId)
        return { deliveryMethod: "MAIL", id: transaction.mailOrderId };
    return null;
}
